module.exports = __webpack_public_path__ + "img/95.b6a3d20d.jpg";